import React from 'react';
import { DateItem } from '../DateItem/DateItem';
import './DateRange.scss';

interface DateRangeProps {
  startDate?: string;
  endDate?: string;
}

const formatDateDisplay = (dateString?: string) => {
  if (!dateString) return { day: '10', month: 'June' };

  const date = new Date(dateString);
  const day = date.getDate().toString();
  const month = date.toLocaleDateString('en-US', { month: 'long' });

  return { day, month };
};

export const DateRange: React.FC<DateRangeProps> = ({ startDate, endDate }) => {
  const startFormatted = formatDateDisplay(startDate);
  const endFormatted = formatDateDisplay(endDate);

  return (
    <div className="date-range">
      <DateItem
        label="START DATE"
        value={startFormatted.day}
        month={startFormatted.month}
        type="start-date"
      />
      <DateItem
        label="END DATE"
        value={endFormatted.day}
        month={endFormatted.month}
        type="end-date"
      />
    </div>
  );
};
